import { validateReferralField } from '@components/ReferralField/validate';
import { ValidationErrorMessages } from '@constants/forms';
import { BooleanSelection } from '@src/types/index';
import { ReferralLegalFormValues } from '@src/types/yourDetails';

import { ReferralLegalFormErrors } from '../types';

const validate = (values: ReferralLegalFormValues): ReferralLegalFormErrors => {
  const errors: ReferralLegalFormErrors = {};
  const refErrors = validateReferralField(values);

  if (values.rlTermsAccept !== BooleanSelection.Yes) {
    errors.rlTermsAccept = ValidationErrorMessages.ACCEPT_TERMS_TO_CONTINUE;
  }

  return { ...errors, ...refErrors };
};

export { validate };
